import { StaticApplicationId } from '../../Constants/static-application-id.enum';
import { SvcParameters } from '../../enums/svc-parameter.enum';

export type CmmsFlagModule = 'unsafeCondition' | 'defectTag';

export const CMMS_FLAG_PARAMETERS: Record<CmmsFlagModule, SvcParameters> = {
  unsafeCondition: SvcParameters.UnsafeConditionShowIntegrationCmms,
  defectTag: SvcParameters.DefectTagShowIntegrationCmms,
};

export const CMMS_CHECKLIST_MENU_APPLICATIONS: Partial<Record<StaticApplicationId, CmmsFlagModule>> = {
  [StaticApplicationId.unsafeCondition]: 'unsafeCondition',
  [StaticApplicationId.defectTag]: 'defectTag',
};

export const CMMS_CHECKLIST_MENU_PATHS: readonly string[] = ['settings/checklist-registration', 'settings/checklist-management', 'settings/checklist'];

export function isCmmsChecklistMenuUrl(url: unknown): boolean {
  if (typeof url !== 'string') {
    return false;
  }
  const path = url.replace(/^\/+/, '').split('?')[0];
  return CMMS_CHECKLIST_MENU_PATHS.some((candidate) => path === candidate || path.startsWith(`${candidate}/`));
}
